import tips from './tips'
import copay from './copay'
import delivery from './delivery'

export default {
  'approve-type': {
    'face-2-face-id-required': {
      label: 'Yêu cầu ID và chữ ký trực tiếp',
      description_1: 'Đơn thuốc sẽ chỉ được giao cho bệnh nhân được chỉ định. Người nhận phải cung cấp cả ID và chữ ký, và ID phải trùng với tên người nhận.',
      description_2: 'Tài xế sẽ chụp ảnh ID của bệnh nhân và cửa khi giao hàng.',
    },
    'face-2-face-not-required': {
      label: 'Không yêu cầu chữ ký trực tiếp',
      description: 'Chữ ký được yêu cầu bởi bất kỳ người lớn 18+ nào sống cùng bệnh nhân. Tài xế sẽ chụp ảnh cửa của bệnh nhân.',
    },
    'face-2-face-required': {
      label: 'Yêu cầu chữ ký trực tiếp',
      description: 'Chữ ký được yêu cầu bởi bất kỳ người nào sống cùng bệnh nhân. Tài xế sẽ chụp ảnh cửa của bệnh nhân.',
    },
    'non-contract-delivery': {
      label: 'Giao hàng không tiếp xúc',
      description: 'Tài xế sẽ để gói hàng bên cửa và chụp ảnh mà không cố gắng giao hàng trực tiếp.',
    },
    'online-signature': {
      label: 'Chữ ký trực tuyến',
      description_1: 'Tài xế sẽ để đơn thuốc bên cửa và chụp ảnh, chỉ',
      description_2: 'nếu người nhận ký trực tuyến trước khi giao hàng. Nếu không có chữ ký trực tuyến, phương thức giao hàng sẽ',
      description_3: 'tiếp tục như "Yêu cầu chữ ký trực tiếp".',
    },
    'signature-optional': {
      label: 'Chữ ký tùy chọn',
      description: 'Tài xế sẽ cố gắng giao hàng trực tiếp. Nếu không có ai ở nhà, tài xế sẽ để gói hàng bên cửa và chụp ảnh.',
    },
  },
  tips,
  copay,
  delivery,
  wait: 'Vui lòng chờ...',
  'promised-eta': 'Thời gian dự kiến hứa hẹn:',
  reschedule: 'Lên lịch lại/Thay đổi địa chỉ',
}
